import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'signup-modal_open_discover_product_tile-click';

/**
 * Event fired when user clicks a product tile in the product list of discover page
 */
export function trackSignupModalOpenDiscoverProductTileClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
